import { NavLink } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import pageStyles from '../styles/page-common.module.css';

<Helmet>
  <title>Login Required | LingoLeaf</title>
  <meta name="description" content="You must be logged in to access this page on LingoLeaf. Please sign in to continue." />
</Helmet>


function LoginRequired() {
  return (
    <>
      <Helmet>
        <title>Login Required | LingoLeaf</title>
        <meta name="description" content="You must be logged in to access this page on LingoLeaf. Please sign in to continue." />
      </Helmet>
      <div className={pageStyles.styledPage}>
        <h1>Login Required</h1>
        <p>You must be logged in to access this page. Please sign in to your account or create a new one to continue.</p>
        <br/>
        <NavLink to="/login" style={{display: 'contents'}}><button>Sign In</button></NavLink>
        <NavLink to="/register" style={{display: 'contents'}}><button>Create Account</button></NavLink>
      </div>
    </>
  );
}

export default LoginRequired;